const formatDate = (moveInDate) => {
	const date = new Date(moveInDate);
	const options = {
		year: "numeric",
		month: "2-digit",
		day: "2-digit",
		timeZone: "UTC"
	};
	const formatter = new Intl.DateTimeFormat("en-US", options);
	return formatter.format(date);
};

export default formatDate;
